export const clientKeys = {
  all: ['client'] as const,
  me: ['client', 'me'] as const,
};
